import { useState } from "react";
import React from 'react';

const ContextToggle = React.createContext();

const ProviderToggle = ({children}) => {
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
    return <ContextToggle.Provider value={{show, handleClose, handleShow }}>
        {children}
    </ContextToggle.Provider>;
}

export {ContextToggle, ProviderToggle};